module.exports = __webpack_public_path__ + "static/img/img-rkkjxzxqy-lc.7959a12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img-rkkjxzxqy-lc.png
// module id = l2h+
// module chunks = 1